<template>
  <div class="contact-us-layout">
    <div v-if="!showDetail">
      <div class="top-tabs-layout">
        <div
          v-for="(item, index) in tabList"
          :key="index"
          :ref="`SLIDING_ROOT${index}`"
          :class="[activated === index ? 'activated' : 'not-activated']"
          class="label"
          @click="onItemClick(index)"
        >
          {{ item.label }}
        </div>
        <div class="sliding-block-root">
          <div ref="SLIDING" class="sliding"></div>
        </div>
      </div>

      <div class="content-layout">
        <div v-if="activated === 0" class="content-contact">
          <div class="top">
            <img class="image" src="@images/bg/cu_we_door.png" alt="" />
            <div class="info-root">
              <div class="name-en" v-if="$i18n.locale === 'en-US'">
                {{ $t('companyName') }}
              </div>
              <div class="name" v-if="$i18n.locale === 'zh-CN'">
                {{ $t('companyName') }}
              </div>
              <div class="info">
                <div class="address">
                  <img src="@images/icon/cu_address.png" alt="" />
                  {{ $t('address') }}
                </div>
                <div class="address">
                  <img src="@images/icon/cu_phone.png" alt="" />
                  0591-87279000
                </div>
                <div class="address">
                  <img src="@images/icon/cu_email.png" alt="" />
                  chinaegg@vip.sina.com
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="activated === 1" class="content-recruitment root-scrollbar">
          <div
            v-for="(item, index) in recruitmentList"
            :key="index"
            :class="{ first: index === 0 }"
            class="recruitment-item"
          >
            <div>
              <span class="port">{{ item.title }}（{{ item.recruitsNum }}名）</span>
              <span class="info">{{ item.city }} | {{ item.workExperience }} | {{ item.salary }} </span>
            </div>
            <div class="detail" @click="onDetail(item.id)">
              <span style="margin-right: 10px">查看详情</span>
              <img style="width: 30px" src="@images/icon/cu_arrow_right.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <detail ref="DETAIL" class="detail-root" @onBack="onExitDetail" />
  </div>
</template>

<script>
import Detail from '@views/components/detail'
import { fetchRecruitmentList } from './model'
export default {
  components: {
    Detail
  },
  data() {
    return {
      activated: 0,
      showDetail: false,
      tabList: [
        {
          label: this.$t('navigation.contactUs')
        }
        //{
        //label: '企业招聘'
        //}
      ],
      slidingX: 0,
      recruitmentList: [],
      language: localStorage.getItem('Language'),
      show: false
    }
  },
  watch: {
    showDetail(val) {
      if (!val) {
        this.setPosition()
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setTransitionX(true, 0)
      this.getRecruitmentList()
    })
  },
  methods: {
    onItemClick(index) {
      if (this.activated === index) return
      const direction = this.activated < index
      const pos = Math.abs(this.activated - index)
      this.setTransitionX(direction, pos)
      this.activated = index
    },
    onDetail(id) {
      this.$refs.DETAIL.init(0, id)
      this.showDetail = true
    },
    onExitDetail() {
      this.showDetail = false
    },
    async getRecruitmentList() {
      const resp = await fetchRecruitmentList()
      this.recruitmentList = resp.data.list
    },
    setTransitionX(direction, pos) {
      const eleRoot = this.$refs['SLIDING_ROOT0'][0]
      const ele = this.$refs.SLIDING
      const marginInline = +window.getComputedStyle(eleRoot).marginLeft.replace('px', '')
      const width = +window.getComputedStyle(eleRoot).width.replace('px', '')
      const slidingItem = pos === 0 ? width / 2 : (width + marginInline * 2) * pos
      const tansV = direction ? slidingItem : -slidingItem
      this.slidingX += tansV
      ele.style.transition = 'transform 0.5s'
      ele.style.transform = `translateX(${this.slidingX}px)`
    },
    setPosition() {
      this.$nextTick(() => {
        const ele = this.$refs.SLIDING
        ele.style.transform = `translateX(${this.slidingX}px)`
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.contact-us-layout {
  background: white;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;

  .top-tabs-layout {
    cursor: default;
    margin: 0 10vw;
    height: 185px;
    display: flex;
    line-height: 209px;
    align-content: center;
    color: #333333;
    font-size: 54px;
    position: relative;

    .label {
      margin: 0 2vw;
      letter-spacing: -1px;
    }

    .sliding-block-root {
      position: absolute;
      bottom: 0;
      height: 10px;
      width: 100%;
      left: 0;

      .sliding {
        width: 4vw;
        height: 100%;
        border-radius: 20px;
        background: #9d1c21;
      }
    }

    .activated {
      font-weight: bold;
    }

    .not-activated {
      font-weight: 400;
    }
  }

  .content-layout {
    height: calc(100vh - 8.55vh - 185px - 8.2vh);

    .content-contact {
      height: 100%;
      width: 100%;
      background: url('~@images/bg/cu_we.png') no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      .top {
        width: 70%;
        height: 62%;
        background: white;
        display: flex;

        .image {
          height: 100%;
          width: 45%;
          flex-shrink: 0;
        }

        .info-root {
          height: 100%;
          margin-left: 2vw;
          display: flex;
          flex-direction: column;

          .name {
            font-family: MicrosoftYaHei-Bold;
            white-space: nowrap;
            height: 9.1443vh;
            font-size: 2.5vw;
            transition: font-size 0.3s ease;
          }
          .name-en {
            font-family: MicrosoftYaHei-Bold;
            font-size: 1.5vw;
            line-height: 2;
            white-space: nowrap;
          }

          .info {
            font-size: 1.4vw;
            color: #333;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            flex: 1;
          }

          .address {
            //line-height: 1vw;
            display: flex;
            align-items: center;

            img {
              width: 3vw;
              margin-right: 20px;
            }
          }
        }
      }

      // .image {
      //   height: 100%;
      //   width: 100vw;
      // }
    }

    .content-recruitment {
      height: 100%;
      background: url('~@images/bg/cu_recruitment.png') no-repeat;
      background-size: 100% 100%;

      .first {
        margin-top: 3vh;
      }
      .recruitment-item {
        display: flex;
        margin-left: 10vw;
        margin-right: 10vw;
        align-items: center;
        background: white;
        height: 131px;
        justify-content: space-between;
        box-shadow: -0px 0px 6px 10px rgba(3, 10, 32, 0.1);

        .port {
          color: #9d1c21;
          font-size: 30px;
          font-weight: bold;
          line-height: 40px;
          margin-left: 39px;
        }

        .info {
          color: #333;
          font-size: 22px;
          line-height: 40px;
          margin-left: 39px;
        }

        .detail {
          border: 2px solid #9d1c21;
          color: #9d1c21;
          border-radius: 25px;
          font-size: 22px;
          line-height: 40px;
          padding: 0 20px;
          margin-right: 39px;
          cursor: pointer;
        }
      }
    }
  }

  .detail-root {
    position: absolute;
    top: 0;
  }
}
</style>
